export const lightTheme = {
  body: "white",
  text: "#121212",
  background: "white",
  gridtext: "var(--text-primary-color)",
  grid1: "var(--light-primary-color)",
  grid2: "var(--default-primary-color)",
  grid3: "var(--dark-primary-color)",
  bb8: "#7c9a9c",
};
export const darkTheme = {
  body: "#121212",
  text: "white",
  background: "#0E1D28",
  gridtext: "var(--text-primary-color)",
  grid1: "var(--secondary-text-color)",
  grid2: "var(--accent-color)",
  grid3: "var(--primary-text-color)",
  bb8: "var(--dark-primary-color)",
};
